export const GET_HOME_DATA = "GET_HOME_DATA";
